import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AppVersion } from '../model/config-file.model';
import { AppState } from '../state/app.state';

@Injectable({
	providedIn: 'root',
})
export class AppInformationService {
	constructor(private oidcSecurityService: OidcSecurityService, private store: Store) {}

	get appName(): string {
		const config = this.oidcSecurityService.getConfigurations();
		let appName = '';
		if (config.length) {
			appName = config[0].clientId;
		}
		return appName;
	}

	get currentUrl(): string {
		const appSate = this.store.selectSnapshot(AppState.getAppState);
		return Object.keys(appSate).length ? appSate[this.appName].currentUrl : null;
	}

	get currentConfigData(): any {
		const appSate = this.store.selectSnapshot(AppState.getAppState);
		return Object.keys(appSate).length ? appSate[this.appName].configData : null;
	}

	get currentmodule(): string {
		const appSate = this.store.selectSnapshot(AppState.getAppState);
		return Object.keys(appSate).length ? appSate[this.appName].currentModule : null;
	}

	get logAcknowledge(): boolean {
		const appSate = this.store.selectSnapshot(AppState.getAppState);
		return Object.keys(appSate).length ? appSate[this.appName].logAcknowledge : null;
	}

	get releaseNotes(): any {
		const appSate = this.store.selectSnapshot(AppState.getAppState);
		return Object.keys(appSate).length ? appSate[this.appName].releaseNotes : null;
	}

	get version(): AppVersion {
		const appSate = this.store.selectSnapshot(AppState.getAppState);
		return Object.keys(appSate).length ? appSate[this.appName].version : null;
	}

	get checkAppInfo(): boolean {
		const appSate = this.store.selectSnapshot(AppState.getAppState);
		return appSate[this.appName] ? true : false;
	}

	/**
	 * Shortcut to get the OIDC token
	 *
	 * @returns OIDC token
	 */
	getOidcToken(): string {
		return this.oidcSecurityService.getAccessToken();
	}
}
